import { render } from "./SelectPayment.vue?vue&type=template&id=240b5230&scoped=true"
import script from "./SelectPayment.vue?vue&type=script&lang=js"
export * from "./SelectPayment.vue?vue&type=script&lang=js"

import "./SelectPayment.vue?vue&type=style&index=0&id=240b5230&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240b5230"]])

export default __exports__